<template>
  <div>
    <snackbar :show="showSnackbar" :color="state" :message="message" @change="(state) => showSnackbar = state"></snackbar>
    <loading-dialog :show="loading"></loading-dialog>
    <confirmation-dialog :show="confirmDialog" @action="confirmationHandler"></confirmation-dialog>
    <field-area @accept="acceptHandler" :title="title" :fields="fields" :data="dialogData" :show="fieldDialog" :action="action" @stateChange="(state) => fieldDialog = state" ></field-area>
    <header-selection :key="headerKey" @accept="acceptHeaderHandler" :title="title" :fields="fields" :show="headerDialog" :activeHeader="activeHeader" @stateChange="(state) => headerDialog = state" ></header-selection>
    <custom-table :title="title" :data="data" :headers="newHeader"
    @action="actionHandler" @customHeader="customHeaderHandler" @refresh="$emit('refresh')" @selection="(item) => $emit('row-selection', item)"></custom-table>
  </div>
</template>

<script>
import FieldArea from '@/components/admin/FieldArea.vue'
import HeaderSelection from '@/components/admin/HeaderSelection.vue'
import CustomTable from '@/components/admin/CustomTable.vue'
import Snackbar from '@/components/admin/SnackBar.vue'
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue'
import LoadingDialog from '@/components/common/LoadingDialog.vue'

import { mapActions } from 'vuex'

export default {
  props: {
    header: Array,
    title: String,
    component: String,
    fields: Array,
    data: Array,
    plant: Number,
    actionEdit: {
      type: Boolean,
      default: false
    },
    actionDelete: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ConfirmationDialog,
    FieldArea,
    CustomTable,
    HeaderSelection,
    Snackbar,
    LoadingDialog
  },
  data() {
    return {
      fieldDialog: false,
      confirmDialog: false,
      headerDialog: false,
      dialogData: {},
      action: '',
      headerSettings: [],
      newHeader: [],
      showSnackbar: false,
      state: 'info',
      message: '',
      loading: false,
      headerKey: 0
    }
  },
  mounted() {
    this.newHeader = this.header
  },
  computed: {
    activeHeader() {
      return this.newHeader.reduce((pre, item) => {
        pre[item.value] = true
        return pre
      }, {})
    }
  },
  methods: {
    ...mapActions('admin', ['saveConfig', 'updateConfig', 'deleteConfig']),
    setupSnackbar(state, message) {
      this.state = state
      this.message = message
      this.showSnackbar = true
    },
    acceptHandler(payload) {
      payload.component = this.component
      payload.values = Object.assign({}, payload.values)
      if (!payload.values.plant_id) { payload.values.plant_id = this.plant }
      console.log(JSON.stringify(payload, null, 2))
      if (payload.action === 'new') {
        this.loading = true
        this.saveConfig(payload).then(res => {
          this.loading = false
          this.setupSnackbar('success', res.data.message)
        }).catch(err => {
          this.loading = false
          this.setupSnackbar('error', err.message)
        })
      } else if (payload.action === 'edit') {
        // Get the identifiers to updated
        const identifiers = this.fields.reduce((id, item) => {
          if (item.identifier) {
            id[item.param] = payload.values[item.param]
            // Avoid identifiers from getting updated
            delete payload.values[item.param]
          }
          return id
        }, {})

        payload.condition = identifiers
        this.loading = true
        this.updateConfig(payload).then(res => {
          this.loading = false
          this.setupSnackbar('success', res.data.message)
        }).catch(err => {
          this.loading = false
          this.setupSnackbar('error', err.message)
        })
      }
    },
    acceptHeaderHandler(headerSetting) {
      this.formHeader(headerSetting)
    },
    confirmationHandler(choice) {
      this.confirmDialog = false
      if (choice === 'agree') {
        const identifier = this.fields.reduce((id, item) => {
          if (item.identifier) {
            id[item.param] = this.dialogData[item.param]
          }
          return id
        }, {})
        this.loading = true
        this.deleteConfig({
          component: this.component,
          identifier
        }).then(res => {
          this.loading = false
          this.setupSnackbar('success', res.data.message)
        }).catch(err => {
          this.loading = false
          this.setupSnackbar('error', err.message)
        })
      }
    },
    actionHandler(eventObj) {
      if (eventObj.action === 'edit') {
        this.fieldDialog = true
        this.dialogData = eventObj.item
        this.action = 'edit'
      } else if (eventObj.action === 'delete') {
        this.confirmDialog = true
        this.dialogData = eventObj.item
        this.action = 'delete'
      } else if (eventObj.action === 'new') {
        this.fieldDialog = true
        this.dialogData = null
        this.action = 'new'
      }
    },
    customHeaderHandler() {
      this.headerKey += 1
      this.headerDialog = true
    },
    formHeader(list) {
      const temp = []
      list.map(item => {
        if (!item.hidden) {
          temp.push({
            text: item.name,
            align: 'left',
            sortable: false,
            value: item.param
          })
        }
      })
      this.newHeader = temp
      if (this.actionEdit || this.actionDelete) {
        const actionHeader = {
          text: 'Action',
          value: 'action',
          align: 'right',
          action: [],
          sortable: false
        }
        if (this.actionEdit) {
          actionHeader.action.push('edit')
        }
        if (this.actionDelete) {
          actionHeader.action.push('delete')
        }
        this.newHeader.push(actionHeader)
      }
    }
  },
  watch: {
    fields() {
      const identifiers = this.fields.filter(item => item.identifier || item.textIdentifier)
      this.formHeader(identifiers)
    },
    header() {
      this.newHeader = this.header
    }
  }
}
</script>

<style></style>
